import { HeatmapAggregationFn } from '@warebee/shared/common';
import { sql } from 'kysely';
import _ from 'lodash';
import {
  ActualityHqDataColumn,
  ActualityHqQueryBuilderParams,
  getActualityHqQueryBuilder,
} from '../cteQueryBuilders/actualityHqQueryBuilder';

export type GetActualityMetricSummaryParams = ActualityHqQueryBuilderParams & {
  groupBy: ActualityHqDataColumn;
  aggregationFn: HeatmapAggregationFn;
  aggregateBy: ActualityHqDataColumn;
};

export function getActualityMetricSummary(
  params: GetActualityMetricSummaryParams,
) {
  return getActualityHqQueryBuilder(params)
    .with(
      cte => cte('aggregated'),
      db =>
        db
          .selectFrom('hq')
          // .$if(params.aggregationFn === 'max', db =>
          //   db.select(({ fn }) => fn.max(params.groupBy).as('dimensionValue')),
          // )
          .select(({ fn }) =>
            _.compact([
              'activityItem',
              'skuKey',
              'locationLevel',
              params.aggregationFn === 'max'
                ? fn.max(params.groupBy).as('dimensionValue')
                : null,
              params.aggregationFn === 'min'
                ? fn.min(params.groupBy).as('dimensionValue')
                : null,
              params.aggregationFn === 'avg'
                ? fn.avg(params.groupBy).as('dimensionValue')
                : null,
              params.aggregationFn === 'sum'
                ? fn.sum(params.groupBy).as('dimensionValue')
                : null,
              params.aggregationFn === 'count'
                ? fn.count('eventId').as('dimensionValue')
                : null,
              params.aggregationFn === 'count-locations'
                ? fn
                    .count<number>(params.groupBy)
                    .distinct()
                    .as('dimensionValue')
                : null,
              params.aggregationFn === 'distinct'
                ? sql.ref(params.groupBy).as('dimensionValue')
                : null,
              params.aggregationFn === 'last'
                ? fn('max_by', [sql.ref(params.groupBy), 'eventEndTime']).as(
                    'dimensionValue',
                  )
                : null,
              fn.count<number>('eventId').distinct().as('totalEvents'),
              fn.count<number>('locationId').distinct().as('totalLocations'),
              fn
                .count<number>('layoutLocationId')
                .distinct()
                .as('totalExistedLocations'),
              fn.count<number>('skuKey').distinct().as('totalItems'),
              fn
                .count<number>('activityItem')
                .distinct()
                .as('totalAssignments'),
            ]),
          )
          .where(eb =>
            eb.or([
              eb('eventType', 'is', null),
              eb(
                'eventType',
                'not in',
                params.activity.informationalEventTypes,
              ),
            ]),
          )
          .groupBy(
            params.aggregationFn === 'distinct'
              ? [
                  'activityItem',
                  'skuKey',
                  'locationLevel',
                  sql.ref(params.groupBy),
                ]
              : ['activityItem', 'skuKey', 'locationLevel'],
          ),
    )

    .selectFrom('aggregated')

    .select(({ fn }) =>
      _.compact([
        'dimensionValue as dimension',
        'locationLevel',
        fn.countAll<number>().as('totalCount'),
        fn.sum<number>('totalEvents').as('totalLines'),
        fn.sum<number>('totalLocations').as('totalLocations'),
        fn.sum<number>('totalExistedLocations').as('totalExistedLocations'),
        fn.count<number>('skuKey').distinct().as('totalItems'),
        fn.count<number>('activityItem').distinct().as('totalAssignments'),
      ]),
    )
    .groupBy(['dimensionValue', 'locationLevel']);
}
